import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Resource from '../entities/resource'
import Cascader from '../entities/cascader'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface ResourceState extends ListState<Resource> {
    editResource: Resource;
    cascaders: any;
    topicCascaders: any;
    resourceCascaders:any;
}
class ResourceModule extends ListModule<ResourceState, any, Resource>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Resource>(),
        loading: false,
        editResource: new Resource(),
        cascaders: new Array<Cascader>(),
        topicCascaders: new Array<Cascader>(),
        resourceCascaders: new Array<Cascader>()
    }
    actions = {
        async getAll(context: ActionContext<ResourceState, any>, payload: any) {
           context.state.loading = true;
            // context.state.totalCount=0;
            // context.state.list=null;
            let reponse = await Ajax.get('/api/services/app/Resource/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Resource>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        }, async getAllModerated(context: ActionContext<ResourceState, any>, payload: any) {
             context.state.loading = true;
            // context.state.totalCount=0;
            // context.state.list=null;            
            let reponse = await Ajax.get('/api/services/app/Resource/GetAllModerated', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Resource>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<ResourceState, any>, payload: any) {
            let reponse =await Ajax.post('/api/services/app/Resource/Create', payload.data);
            return reponse.data.result;
        },
        async update(context: ActionContext<ResourceState, any>, payload: any) {
            await Ajax.put('/api/services/app/Resource/Update', payload.data);
        },
        async delete(context: ActionContext<ResourceState, any>, payload: any) {
            await Ajax.delete('/api/services/app/Resource/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<ResourceState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Resource/Get?Id=' + payload.id);
            return reponse.data.result as Resource;
        },
        async getCascader(context: ActionContext<ResourceState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetBehindCascaderList', { params: payload.data });
            //context.state.loading = false;
            context.state.cascaders = reponse.data.result as Array<Cascader>;
        },
        async getTopicCascader(context: ActionContext<ResourceState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderList', { params: payload.data });
            context.state.topicCascaders = reponse.data.result as Array<Cascader>;
            let reponseResource = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderList', { params: { classTypeId: 5 } });
            context.state.resourceCascaders=reponseResource.data.result as Array<Cascader>;
        },
        async placedTopResource(context: ActionContext<ResourceState, any>, payload: any) {
            await Ajax.post('/api/services/app/Resource/PlacedTopResource', payload.data);
        },
        async auditedResource(context: ActionContext<ResourceState, any>, payload: any) {
            await Ajax.post('/api/services/app/Resource/AuditedResource', payload.data);
        }
    };
    mutations = {
        setCurrentPage(state: ResourceState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ResourceState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: ResourceState, resource: Resource) {
            state.editResource = resource;
        }
    }
}
const resourceModule = new ResourceModule();
export default resourceModule;